import { StatusResponse } from '../../models/StatusResponse';
import { UseCase } from '../UseCase';
import { SessionRepository } from '../../repositories/SessionRepository';

export class ChangeSessionTimeUseCase implements UseCase<ChangeSessionTimeRequestDto, StatusResponse>{

    constructor(
        private sessionRepo: SessionRepository
    ) { }
    
    execute(t: ChangeSessionTimeRequestDto): Promise<StatusResponse> {
        return this.sessionRepo.updateSessionTime(t.timeInMillis);
    }

}

export class ChangeSessionTimeRequestDto {
    constructor(
        public timeInMillis: number
    ) { }
}